import { ParseQuery } from './parse-query';

import { Menu } from './../data';

export class MenuQuery extends ParseQuery<Menu> {
  constructor() {
    super(Menu);
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/queries/menu-query.ts